@if (group) {
  <vwui-collapse [collapseTitle]="group.title">
    <vwui-spacer-group spacing="xxs">
      @for (control of formArray.controls; track control; let i = $index) {
        <vwui-checkbox
          [formControl]="$any(control)">
          {{ group.options[i].value }}
        </vwui-checkbox>
      }
    </vwui-spacer-group>
  </vwui-collapse>
}
